export function getParams(state) {
    return state.params
}

export function subBrandsList(state) {
    return state.subbrandsList;
}


// WEBPACK FOOTER //
// ./src/modules/subbrands/getters.js